/* istanbul ignore file */
import { createContext } from 'react';

import { defaultTggTheme, Theme } from '../../theme';

export const TggThemeContext = createContext<{ theme: Theme }>({
    theme: defaultTggTheme,
});
